// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}



.card {
  background: #fff;
  transition: .5s;
  border: 0;
  margin-bottom: 30px;
  border-radius: .55rem;
  position: relative;
  width: 100%;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 10%);
}
.chat-app .people-list {
  width: 280px;
  position: absolute;
  left: 0;
  top: 0;
  padding: 20px;
  z-index: 7
}

.chat-app .chat {
  margin-left: 280px;
  border-left: 1px solid #eaeaea
}

.people-list {
  transition: .5s
}

.people-list .chat-list li {
  padding: 10px 15px;
  list-style: none;
  border-radius: 3px
}

.people-list .chat-list li:hover {
  background: #efefef;
  cursor: pointer
}

.people-list .chat-list li.active {
  background: #efefef
}

.people-list .chat-list li .name {
  font-size: 15px
}

.people-list .chat-list img {
  width: 45px;
  border-radius: 50%
}

.people-list img {
  float: left;
  border-radius: 50%
}

.people-list .about {
  float: left;
  padding-left: 8px
}

.people-list .status {
  color: #999;
  font-size: 13px
}

.chat .chat-header {
  padding: 15px 20px;
  border-bottom: 2px solid #f4f7f6
}

.chat .chat-header img {
  float: left;
  border-radius: 40px;
  width: 40px
}

.chat .chat-header .chat-about {
  float: left;
  padding-left: 10px
}

.chat .chat-history {
  padding: 20px;
  border-bottom: 2px solid #fff
}

.chat .chat-history ul {
  padding: 0
}

.chat .chat-history ul li {
  list-style: none;
  margin-bottom: 30px
}

.chat .chat-history ul li:last-child {
  margin-bottom: 0px
}

.chat .chat-history .message-data {
  margin-bottom: 15px
}

.chat .chat-history .message-data img {
  border-radius: 40px;
  width: 40px
}

.chat .chat-history .message-data-time {
  color: #434651;
  padding-left: 6px
}

.chat .chat-history .message {
  color: #444;
  padding: 18px 20px;
  line-height: 26px;
  font-size: 16px;
  border-radius: 7px;
  display: inline-block;
  position: relative
}

.chat .chat-history .message:after {
  bottom: 100%;
  left: 7%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-bottom-color: #fff;
  border-width: 10px;
  margin-left: -10px
}

.chat .chat-history .my-message {
  background: #efefef
}

.chat .chat-history .my-message:after {
  bottom: 100%;
  left: 30px;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-bottom-color: #efefef;
  border-width: 10px;
  margin-left: -10px
}

.chat .chat-history .other-message {
  background: #e8f1f3;
  text-align: right
}

.chat .chat-history .other-message:after {
  border-bottom-color: #e8f1f3;
  left: 93%
}

.chat .chat-message {
  padding: 20px
}

.online,
.offline,
.me {
  margin-right: 2px;
  font-size: 8px;
  vertical-align: middle
}

.online {
  color: #86c541
}

.offline {
  color: #e47297
}

.me {
  color: #1d8ecd
}

.float-right {
  float: right
}

.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;;;AAIA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,wCAAwC;AAC1C;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,aAAa;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EAIE;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB;AACF;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;EACpB,4BAA4B;EAC5B,kBAAkB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,4BAA4B;EAC5B;AACF;;AAEA;EACE;AACF;;AAEA;;;EAGE,iBAAiB;EACjB,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,WAAW;EACX;AACF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n\n\n.card {\n  background: #fff;\n  transition: .5s;\n  border: 0;\n  margin-bottom: 30px;\n  border-radius: .55rem;\n  position: relative;\n  width: 100%;\n  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 10%);\n}\n.chat-app .people-list {\n  width: 280px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  padding: 20px;\n  z-index: 7\n}\n\n.chat-app .chat {\n  margin-left: 280px;\n  border-left: 1px solid #eaeaea\n}\n\n.people-list {\n  -moz-transition: .5s;\n  -o-transition: .5s;\n  -webkit-transition: .5s;\n  transition: .5s\n}\n\n.people-list .chat-list li {\n  padding: 10px 15px;\n  list-style: none;\n  border-radius: 3px\n}\n\n.people-list .chat-list li:hover {\n  background: #efefef;\n  cursor: pointer\n}\n\n.people-list .chat-list li.active {\n  background: #efefef\n}\n\n.people-list .chat-list li .name {\n  font-size: 15px\n}\n\n.people-list .chat-list img {\n  width: 45px;\n  border-radius: 50%\n}\n\n.people-list img {\n  float: left;\n  border-radius: 50%\n}\n\n.people-list .about {\n  float: left;\n  padding-left: 8px\n}\n\n.people-list .status {\n  color: #999;\n  font-size: 13px\n}\n\n.chat .chat-header {\n  padding: 15px 20px;\n  border-bottom: 2px solid #f4f7f6\n}\n\n.chat .chat-header img {\n  float: left;\n  border-radius: 40px;\n  width: 40px\n}\n\n.chat .chat-header .chat-about {\n  float: left;\n  padding-left: 10px\n}\n\n.chat .chat-history {\n  padding: 20px;\n  border-bottom: 2px solid #fff\n}\n\n.chat .chat-history ul {\n  padding: 0\n}\n\n.chat .chat-history ul li {\n  list-style: none;\n  margin-bottom: 30px\n}\n\n.chat .chat-history ul li:last-child {\n  margin-bottom: 0px\n}\n\n.chat .chat-history .message-data {\n  margin-bottom: 15px\n}\n\n.chat .chat-history .message-data img {\n  border-radius: 40px;\n  width: 40px\n}\n\n.chat .chat-history .message-data-time {\n  color: #434651;\n  padding-left: 6px\n}\n\n.chat .chat-history .message {\n  color: #444;\n  padding: 18px 20px;\n  line-height: 26px;\n  font-size: 16px;\n  border-radius: 7px;\n  display: inline-block;\n  position: relative\n}\n\n.chat .chat-history .message:after {\n  bottom: 100%;\n  left: 7%;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n  border-bottom-color: #fff;\n  border-width: 10px;\n  margin-left: -10px\n}\n\n.chat .chat-history .my-message {\n  background: #efefef\n}\n\n.chat .chat-history .my-message:after {\n  bottom: 100%;\n  left: 30px;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n  border-bottom-color: #efefef;\n  border-width: 10px;\n  margin-left: -10px\n}\n\n.chat .chat-history .other-message {\n  background: #e8f1f3;\n  text-align: right\n}\n\n.chat .chat-history .other-message:after {\n  border-bottom-color: #e8f1f3;\n  left: 93%\n}\n\n.chat .chat-message {\n  padding: 20px\n}\n\n.online,\n.offline,\n.me {\n  margin-right: 2px;\n  font-size: 8px;\n  vertical-align: middle\n}\n\n.online {\n  color: #86c541\n}\n\n.offline {\n  color: #e47297\n}\n\n.me {\n  color: #1d8ecd\n}\n\n.float-right {\n  float: right\n}\n\n.clearfix:after {\n  visibility: hidden;\n  display: block;\n  font-size: 0;\n  content: \" \";\n  clear: both;\n  height: 0\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
